// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"356a7da1","453":"a5618421","455":"dcc53725"}[chunkId] + ".chunk.js";
};